import React from "react";
import {
  ChevronRight,
  FileText,
  HelpCircle,
  Info,
  Mail,
  Phone,
  Ticket,
} from "lucide-react";

import { socials } from "../../constant";
import {
  ABOUT_URL,
  CONTACT_URL,
  PRIVACY_URL,
  SUPPORT_EMAIL,
} from "../../constant/links";
import SettingsSection from "./components/SettingsSection";

const LINKS = [
  {
    title: "About us",
    description: "Learn about DeeX",
    href: ABOUT_URL,
    icon: Info,
  },
  {
    title: "FAQs",
    description: "Answered questions about DeeX",
    href: ABOUT_URL,
    icon: HelpCircle,
  },
  {
    title: "Lodge a complaint",
    description: "Tell us if anything is wrong",
    href: CONTACT_URL,
    icon: Ticket,
  },
  {
    title: "Terms and privacy",
    description: "Read our privacy policy",
    href: PRIVACY_URL,
    icon: FileText,
  },
];

const Support = () => (
  <div className="space-y-6">
    <SettingsSection
      title="Need help? Talk to us"
      description="We usually reply within a few hours on business days."
    >
      <div className="space-y-3">
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="flex items-center gap-3 rounded-xl border px-4 py-3 transition-colors hover:bg-muted"
        >
          <Mail className="size-5 shrink-0 text-muted-foreground" />
          <span className="min-w-0 flex-1 truncate text-[14px] font-medium text-foreground">
            {SUPPORT_EMAIL}
          </span>
        </a>
        <a
          href="tel:+2348163350001"
          className="flex items-center gap-3 rounded-xl border px-4 py-3 transition-colors hover:bg-muted"
        >
          <Phone className="size-5 shrink-0 text-muted-foreground" />
          <span className="min-w-0 flex-1 truncate text-[14px] font-medium text-foreground">
            +234 816 335 0001
          </span>
        </a>
      </div>

      <div className="mt-5 border-t pt-5">
        <p className="text-[13px] font-semibold text-foreground">
          Reach us on social media
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          {socials.map((social: any) => (
            <a
              key={social.id}
              href={social.link}
              target="_blank"
              rel="noreferrer"
              aria-label={social.name ?? "Social link"}
              className="flex size-8 items-center justify-center rounded-lg transition-opacity hover:opacity-80"
              style={{ backgroundColor: social.color }}
            >
              <social.icon className="text-[16px] text-white" />
            </a>
          ))}
        </div>
      </div>
    </SettingsSection>

    <SettingsSection title="Resources">
      <ul className="space-y-3">
        {LINKS.map((link) => (
          <li key={link.title}>
            <a
              href={link.href}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 rounded-xl border px-4 py-3 transition-colors hover:bg-muted"
            >
              <link.icon className="size-5 shrink-0 text-muted-foreground" />
              <span className="min-w-0 flex-1">
                <span className="block text-[14px] font-semibold text-foreground">
                  {link.title}
                </span>
                <span className="block text-[12px] font-medium text-muted-foreground">
                  {link.description}
                </span>
              </span>
              <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
            </a>
          </li>
        ))}
      </ul>
    </SettingsSection>
  </div>
);

export default Support;
